export default __webpack_public_path__ + "fonts/DSM-Icons.woff";